import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../theme';
import { Container, RewardContainer, RewardText } from './SalesToLevel';
import { Text as SellerProfileText } from './SellerProfile';
import { Card } from '@tremor/react';
import Link from 'next/link';
import { Compass } from 'lucide-react';

const Text = styled(SellerProfileText)`
  width: 90%;
`;

type PurchasesToNoFeeProps = {
  purchasesUntilNoFee: number;
};

const TidalFullIcon = (props: { currentIconLength: number }) => (
  <Image
    className="h-20 w-20"
    alt="full_icon"
    height="100"
    width="100"
    objectFit="contain"
    key={props.currentIconLength}
    src={`/images/buyer-progress/${
      props.currentIconLength < 4 ? 'full.svg' : 'last.svg'
    }`}
  />
);

const TidalEmptyIcon = (props: { currentIconLength: number }) => (
  <Image
    className="h-10 w-10"
    alt="empty_icon"
    height="100"
    width="100"
    objectFit="contain"
    key={props.currentIconLength}
    src={`/images/buyer-progress/empty.svg`}
  />
);

const CopsupplyFullIcon = (props: { currentIconLength: number }) => (
  <div
    style={{
      height: 60,
      borderRadius: '100%',
      width: 60,
      backgroundColor: COLORS.ACCENT,
    }}
  />
);

const CopsupplyEmptyIcon = (props: { currentIconLength: number }) => (
  <div
    style={{
      height: 60,
      borderRadius: '100%',
      width: 60,
      backgroundColor: '#cccccc',
    }}
  />
);

const BotmartFullIcon = (props: { currentIconLength: number }) => (
  <div
    style={{
      height: 60,
      width: 60,
      borderRadius: '100%',
      backgroundColor: COLORS.ACCENT,
    }}
    key={props.currentIconLength}
  />
);

const BotmartEmptyIcon = (props: { currentIconLength: number }) => (
  <div
    style={{
      height: 60,
      width: 60,
      borderRadius: '100%',
      backgroundColor: '#cccccc',
    }}
    key={props.currentIconLength}
  />
);

const whiteLabelFullIcons = {
  undefined: TidalFullIcon,
  null: TidalFullIcon,
  botmart: BotmartFullIcon,
  copsupply: CopsupplyFullIcon,
};

const whiteLabelEmptyIcons = {
  undefined: TidalEmptyIcon,
  null: TidalEmptyIcon,
  botmart: BotmartEmptyIcon,
  copsupply: CopsupplyEmptyIcon,
};

export const PurchasesToNoFee = (props: PurchasesToNoFeeProps) => {
  const whiteLabelOrg = process.env.WHITE_LABEL_ORG;
  const icons = [];
  const emptyIconAmount = props.purchasesUntilNoFee;
  const fullIconAmount = 5 - emptyIconAmount;
  const isFull = emptyIconAmount === 0;
  const FullIcon = whiteLabelFullIcons[whiteLabelOrg];
  const EmptyIcon = whiteLabelEmptyIcons[whiteLabelOrg];
  for (let i = 0; i < fullIconAmount; i++) {
    icons.push(<FullIcon currentIconLength={icons.length} />);
  }
  for (let i = 0; i < emptyIconAmount; i++) {
    icons.push(<EmptyIcon currentIconLength={icons.length} />);
  }

  return (
    <Card className="h-full p-4 flex flex-col justify-center min-h-[9rem]">
      <div className="flex flex-row">
        <Text className="w-fit my-auto">
          Purchases until no-fee transaction
        </Text>
        <Link
          href="/bots"
          className="ml-auto font-bold text-md text-tremor-brand"
        >
          <p className="flex">
            Browse Bots
            <Compass className="w-6 h-6 p-1 hidden md:block" />
          </p>
        </Link>
      </div>
      <div className="flex flex-row justify-center my-auto flex-wrap">
        {icons.map((i) => i)}
        <style jsx>
          {`
            img {
              filter: drop-shadow(0px 3px 21px ${COLORS.ACCENT});
              will-change: filter;
            }
          `}
        </style>
      </div>
      {isFull ? (
        <RewardContainer>
          <RewardText>A no-fee transaction is available.</RewardText>
        </RewardContainer>
      ) : null}
    </Card>
  );
};
